import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PointsMngPenalty, PointsMngPoolPoint, PointsMngScrubberPoint } from 'src/app/interface/overview.interface';
import { DistributionDataService } from 'src/app/services/distributionData.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';

@Component({
  selector: 'app-points-management',
  templateUrl: './points-management.component.html',
  styleUrls: ['./points-management.component.scss']
})
export class PointsManagementComponent implements OnInit {
  @Input() shipDetailsbasicinfo : any;
  @Input() poolPointDetails:any;
  @Input() scrubberPointDetails:any;
  @Input() isScrubberVisible:any;
  @Output() emitSelectedTab = new EventEmitter();
  editPointsText:string = 'Edit Pool Points'
  openEditPoolPoints:boolean = false;
  selectedPagetab: string = '';
  showPenaltyHistory :boolean = false;
  penaltyText:string = 'Add penalty';
  endpenaltyText:string = 'End penalty';
  showPointsTab: boolean = false;
  storeVslnumber: any;
  // poolPointDetails: any;
  openPenaltyModal:boolean = false;
  openEndPenaltyModal: boolean = false;
  public subscription: Subscription;
  penaltyForm: any;
  penaltyDates: any;
  penaltyEndDates:any;
  penaltyResons: string = '';
  penaltydateOnly: any;
  penaltytimeOnly: any;
  penaltyenddateOnly:any;
  penaltyendtimeOnly:any;
  addPenaltydetails:any;
  openPenaltyFlow: string = '';
  showPenalty:boolean = false;
  endPenaltyDetails: any;
  calculatedPenaltyVal: any;
  removePenalty:boolean = false;
  removePenaltyReasons: string = '';
  isUsedinCalculation: boolean = true;
  removePenaltyPageLoadData: any;
  effectedMonthsArray: any = [];
  toolTipConfig: {
    width: "auto"
  }
  updatePoolPointsData: any;
  // scrubberPointDetails: any;
  updateScrubberPointsData: any;
  // editPoolPointsVal: boolean = false;;

  pointsMngPenaltyInterface:PointsMngPenalty = {
    isLoader: false
  };
   pointsMngPoolPointInterface:PointsMngPoolPoint= {
    isLoader: false
  };
  pointsMngScrubberPointInterface:PointsMngScrubberPoint= {
    isLoader: false
  };
  constructor(private vesselService:VesselsService,
    private router:Router,
    private distributionService:DistributionDataService,
    private toasterService: ToasterService,
    private cdr:ChangeDetectorRef,
    private datePipe: DatePipe) {    
  }

  ngOnInit() {
    console.log(this.shipDetailsbasicinfo)
    console.log(this.addPenaltydetails)
    console.log(this.poolPointDetails)
      if(this.shipDetailsbasicinfo?.isPenaltyOngoing){
        this.showPenalty = true;
      }else{
        this.showPenalty = false;
      }
      this.subscription =  this.distributionService.changeFleet.subscribe((res:any)=>{
      if(res){
        this.goBack();
      }
    })
    this.updatePoolPointsData = {};
    if(this.isScrubberVisible?.currentScrubberUsage){
      this.updateScrubberPointsData = {};
    }
   
  }
  getPenaltyEvent(){
    this.openPenaltyFlow  = '';
    this.openPenaltyModal = true;
    this.openPenaltyFlow = 'addpenlaty'
    console.log(this.openPenaltyFlow)
  }
  penaltyValues(e:any){
    this.penaltyForm = e;
    console.log(e)

  }
  penaltyDate(e:any){
    this.penaltyDates = e;
    this.penaltydateOnly = this.datePipe.transform(this.penaltyDates,"yyyy-MM-dd");
    console.log(this.penaltydateOnly)
    this.penaltytimeOnly = this.datePipe.transform(this.penaltyDates, 'HH:mm');
    console.log(this.penaltytimeOnly)
  }
  penaltyEndDate(e:any){
    this.penaltyEndDates = e;
    this.penaltyenddateOnly = this.datePipe.transform(this.penaltyEndDates,"yyyy-MM-dd");
    console.log(this.penaltyenddateOnly)
    this.penaltyendtimeOnly = this.datePipe.transform(this.penaltyEndDates, 'HH:mm');
    console.log(this.penaltyendtimeOnly)
  }
  penaltyReason(e:any){
    this.penaltyResons = e;
  }
  calculatedPenaltyValues(e:any){
    this.calculatedPenaltyVal = e;
  }
  savePenalty(){
    this.pointsMngPenaltyInterface.isLoader = true;
    let penaltyVal = (this.shipDetailsbasicinfo?.poolPoint - this.calculatedPenaltyVal).toFixed(2);
    let payLoad = {
      "vslCode": this.shipDetailsbasicinfo?.vslCode,
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "vslOwner": this.shipDetailsbasicinfo?.vslOwner,
      // ---- 34 - effectivePoolpts parseFloat(input).toFixed(2)
      "penaltyValue": Number(penaltyVal),
      "penaltyPercentage": parseFloat(this.penaltyForm.value.penalty),
      "penaltyEffectiveDate": this.penaltydateOnly,
      "penaltyEffectiveTime": this.penaltytimeOnly,
      "penaltyReason":  this.penaltyResons
    }
   this.vesselService.addPenalty(payLoad).subscribe({
    next:(res:any)=>{
      console.log(res)
      if( res?.data?.addPenalty?.statusCode === 200){
        this.addPenaltydetails = res?.data?.addPenalty?.data;
        this.showPenalty = true;
        this.refreshPoolPointDetails();
        this.endPenaltyDetails = {};
        this.pointsMngPenaltyInterface.isLoader = false;
        this.toasterService.openToast('Success', res?.data?.addPenalty?.message);
      }else{
        this.showPenalty = false;
        this.toasterService.openToast('Error', res?.data?.addPenalty?.message);
        this.addPenaltydetails = {};
        this.pointsMngPenaltyInterface.isLoader = false;
      }
    },
    error:(error:any)=>{
      this.showPenalty = false;
      this.toasterService.openToast('Error', error);
      this.addPenaltydetails = {};
      this.pointsMngPenaltyInterface.isLoader = false;
      // this.toasterService.openToast('Success', res?.data?.addPenalty?.message);
    }
   })

  }
  cancelPenalty(){
    this.penaltyForm = '';
    this.penaltyDates = null;
    this.penaltyResons = '';
    this.penaltyEndDates = null;
    this.openPenaltyFlow  = '';
    console.log(this.penaltyResons, this.penaltyDates,this.penaltyForm)
    this.vesselService.cancelPenalty.next(true);
  }
  endPenaltyEvent(){
    this.openPenaltyFlow  = '';
    this.openEndPenaltyModal = true;
    this.openPenaltyFlow = 'endPenalty'
    console.log(this.openPenaltyFlow)
   
  }

  saveendPenalty(){
    this.pointsMngPenaltyInterface.isLoader = true;
     let payLoad = {
      "vslCode": this.addPenaltydetails ? this.addPenaltydetails?.vslCode : this.shipDetailsbasicinfo?.vslCode,
      "vslNumber": this.addPenaltydetails ? this.addPenaltydetails?.vslNumber : this.shipDetailsbasicinfo?.vslNumber,
      "penaltyValue": this.addPenaltydetails ? this.addPenaltydetails?.penaltyValue : this.shipDetailsbasicinfo?.penaltyValue,
      "penaltyPercentage": this.addPenaltydetails ? this.addPenaltydetails?.penaltyPercentage : this.shipDetailsbasicinfo?.penaltyPercentage,
      "penaltyCloseEffectiveDate": this.penaltyenddateOnly,
      "penaltyCloseEffectiveTime": this.penaltyendtimeOnly,
      "penaltyReason": "Ending Penalty"
    }
   this.vesselService.endPenalty(payLoad).subscribe({
    next:(res:any)=>{
      console.log(res)
      if( res?.data?.endPenalty?.statusCode === 200){
        this.endPenaltyDetails = res?.data?.endPenalty?.data;
        this.showPenalty = false;
        this.addPenaltydetails = {};
        this.pointsMngPenaltyInterface.isLoader = false;
        this.refreshPoolPointDetails();
        this.toasterService.openToast('Success', res?.data?.endPenalty?.message);
      }else{
        this.showPenalty = true;
        this.endPenaltyDetails = {};
        this.pointsMngPenaltyInterface.isLoader = false;
        this.toasterService.openToast('Error', res?.data?.endPenalty?.message);
      }
    },
    error:(error:any)=>{
      this.showPenalty = true;
      this.endPenaltyDetails = {};
      this.pointsMngPenaltyInterface.isLoader = false;
      this.toasterService.openToast('Error', error);
    }
   })
  }
  removePenaltyEvent(){
    this.removePenalty = true;
    this.openPenaltyFlow = 'removePenalty'
    this.openEndPenaltyModal = false;
    this.removePenaltyReasons = '';
    this.getRemovePenaltyPageLoad();
  }
  removePenaltyReason(e:any){
    this.removePenaltyReasons = e;
  }
  cancelRemovePenalty(){
    
    this.openPenaltyFlow = '';
    this.removePenalty = false;
    document.body.style.overflow = 'auto';
  }
  penaltyRemoved(){
    this.pointsMngPenaltyInterface.isLoader = true;
    let removePenaltyTodayDate = new Date();
    console.log(removePenaltyTodayDate)
    let removePenaltyOnlyDate = this.datePipe.transform(removePenaltyTodayDate,"yyyy-MM-dd");
    let removePenaltyOnlyTime = this.datePipe.transform(removePenaltyTodayDate, 'HH:mm');
    let payLoad = {
      "vslCode": this.shipDetailsbasicinfo?.vslCode,
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "penaltyValue": this.removePenaltyPageLoadData ? this.removePenaltyPageLoadData?.penaltyValue : this.shipDetailsbasicinfo?.penaltyValue,
      "penaltyPercentage": this.removePenaltyPageLoadData ? this.removePenaltyPageLoadData?.penaltyPercentage : this.shipDetailsbasicinfo?.penaltyPercentage,
      "penaltyCloseEffectiveDate": removePenaltyOnlyDate,
      "penaltyCloseEffectiveTime": removePenaltyOnlyTime,
      "penaltyReason": this.removePenaltyReasons
    }
    this.vesselService.removePenalty(payLoad).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.removePenalty?.statusCode === 200){
          this.showPenalty = false;
          this.refreshPoolPointDetails();
          this.pointsMngPenaltyInterface.isLoader = false;
          this.removePenaltyReasons = '';
          this.toasterService.openToast('Success', res?.data?.removePenalty?.message);
        }else{
          this.pointsMngPenaltyInterface.isLoader = false;
          this.removePenaltyReasons = '';
          this.toasterService.openToast('Error', res?.data?.removePenalty?.message);
        }
      },
      error:(error:any)=>{
        this.showPenalty = true;
        this.removePenaltyReasons = '';
        this.pointsMngPenaltyInterface.isLoader = false;
        this.toasterService.openToast('Error', error?.data?.removePenalty?.message);
      }
    })
  }
  getRemovePenaltyPageLoad(){
    let payLoad = {
      "vslCode": this.shipDetailsbasicinfo?.vslCode,
      "vslNumber":  this.shipDetailsbasicinfo?.vslNumber
    }
    this.vesselService.removePenaltyOnPageLoad(payLoad).subscribe({
      next:(res:any)=>{
        console.log(res);
        this.removePenaltyPageLoadData = res?.data?.removePenaltyPageLoad?.data;
        this.isUsedinCalculation = this.removePenaltyPageLoadData?.alreadyUsedInCalculation;
        this.effectedMonthsArray = this.removePenaltyPageLoadData?.effectedMonths
        console.log( this.isUsedinCalculation)
      },
      error:(error:any)=>{

      }
    })
  }
  penaltyHistory(){
    this.selectedPagetab = 'penaltyHistory';
    console.log(this.selectedPagetab)
    this.vesselService.saveSelectedTab.next(true);
    // this.showPenaltyHistory = true;
  }
 
  goBack(){
    this.vesselService.storePoolval = '';
    this.router.navigate(["fleetmanagement"])
    this.distributionService.changeFleet.next(false);

  }
  goBackToPool(){
    this.router.navigate(["fleetmanagement"])
    this.distributionService.changeFleet.next(false);
  }
  poolPointLoader(){
    this.pointsMngPoolPointInterface.isLoader = true;
  }
  errorPoolPointLoader(){
    this.pointsMngPoolPointInterface.isLoader = false;
  }
  updatePoolPointsVal(e:any){
    this.poolPointDetails = {};
    this.updatePoolPointsData = e;
    this.poolPointDetails = this.updatePoolPointsData?.poolPointDetails;
    this.pointsMngPoolPointInterface.isLoader = false;
    console.log("this.updatePoolPointsData",this.updatePoolPointsData)
    this.shipDetailsbasicinfo = {...this.shipDetailsbasicinfo, poolPoint:this.updatePoolPointsData?.poolPointDetails?.currentPoolPoint}
    this.cdr.detectChanges();
    console.log("saa",this.poolPointDetails)
  }
  private refreshPoolPointDetails() {
    this.poolPointLoader();
    const payload = { vslNumber: this.shipDetailsbasicinfo?.vslNumber };
    this.vesselService.getPoolPointDetails(payload).subscribe({
      next: (res:any) => {
        const details = res?.data?.getPoolPointDetails?.data;
        if (details) {
          this.poolPointDetails = details.poolPointDetails ?? details;
        }
        this.errorPoolPointLoader();
      }
    });
  }

  scrubberPointLoader(){
    this.pointsMngScrubberPointInterface.isLoader = true;
  }
  errorScrubberPointLoader(){
    this.pointsMngScrubberPointInterface.isLoader = false;
  }
  updateScrubberPointsVal(e:any){
    this.scrubberPointDetails = {};
    this.updateScrubberPointsData = e;
    this.scrubberPointDetails = this.updateScrubberPointsData?.scrubberPointDetails;
    this.pointsMngScrubberPointInterface.isLoader = false;
    console.log("this.updateScrubberPointsData",this.updateScrubberPointsData)
    console.log( this.scrubberPointDetails)
  }
}
